
export default class UpArrow {
  constructor(element) {
    this.passedElement = element;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElements();
      this.addEventListeners();
    }
  }

  getElements = () => {
    this.arrow = this.passedElement;
  }

  handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  addEventListeners = () => {
    this.arrow.addEventListener('click', this.handleClick);
  }

  removeEventListeners = () => {
    this.arrow.removeEventListener('click', this.handleClick);
  }

  dismantle = () => {
    this.removeEventListeners();
    this.passedElement = null;
    this.initialised = false;
  }

}
